'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tabs = function () {
  function Tabs(el) {
    _classCallCheck(this, Tabs);

    this.el = el;

    this.ulList = this.el.querySelectorAll('ul')[0];
    this.itemsList = this.el.querySelectorAll('li');
    this.contentsList = this.el.querySelectorAll('.content-item');

    this.onClick(this.itemsList[0]);

    //events
    this.events();
  }

  _createClass(Tabs, [{
    key: 'events',
    value: function events() {
        for (var i = 0; i < this.itemsList.length; i++) {
            this.itemsList[i].addEventListener('click', this.onClickEvent.bind(this));
        }
    }
  }, {
    key: 'onClickEvent',
    value: function onClickEvent(ev) {
        console.log(ev);
        ev.preventDefault();this.onClick(ev.target);
    }
  }, {
    key: 'onClick',
    value: function onClick(item) {
        item = $(item);
        console.log("CLICK",item);
        $(this.itemsList).removeClass('active');
        item.addClass('active');
        $(this.ulList).toggleClass('expanded');
        $(this.contentsList).removeClass('show');
        $("#"+item.attr('data-id')).addClass('show');
    }
  }]);

  return Tabs;
}();

var init = function init() {
  var elements = document.querySelectorAll('.tabs');
  Array.prototype.forEach.call(elements, function (el, i) {
    new Tabs(el);
  });
};

domUtils.ready(init);
